import AxiosLib, { AxiosResponse, InternalAxiosRequestConfig } from "axios";

import i18n from "@/lib/i18n";
import app from "@/main";
import { configuration } from "@/configuration";

i18n.mergeLocaleMessage("fr", {
	"request.not.authorized": "Vous n'êtes pas autorisé à effectuer cette requête.",
	"request.internal.error": "Une erreur du serveur est survenue.",
	"request.network.error": "Impossible de contacter le serveur dû à une erreur réseau.",
	"request.bad.request": "Une erreur est survenue lors de la requête au serveur."
});

const hub = AxiosLib.create({
	baseURL: configuration.backend.hub.apiUrl
});

hub.interceptors.request.use(requestInterceptor);
hub.interceptors.response.use(responseInterceptor);

const replicable = AxiosLib.create({
	baseURL: configuration.backend.replicable.apiUrl
});

replicable.interceptors.request.use(requestInterceptor);
replicable.interceptors.response.use(responseInterceptor);

let activeRequests = 0;

function requestInterceptor(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
	if (!activeRequests) {
		app.$Progress.start();
	}

	activeRequests++;

	return config;
}

function responseInterceptor(response: AxiosResponse<any>): AxiosResponse<any> {
	activeRequests = Math.max(0, activeRequests--);

	if (!activeRequests) {
		app.$Progress.finish();
	}

	return response;
}

export { hub, replicable };
